"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmojiAltIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("../SVGBox");
var themes_1 = require("../../../themes");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 26 26" }, rest, { children: [jsx_runtime_1.jsx("circle", { cx: "13", cy: "13", r: "12", stroke: "black", strokeWidth: "1", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M13 22C16.735 22 19.8721 19.4405 20.7531 15.9798C21.0257 14.9093 20.1046 14 19 14H7C5.89543 14 4.97435 14.9093 5.24685 15.9798C6.12788 19.4405 9.26504 22 13 22Z", fill: fill ? themes_1.THEME.colors.basic.White100 : 'transparent', stroke: "black", strokeWidth: "1" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "9", cy: "10", r: "1", fill: "black" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "17", cy: "10", r: "1", fill: "black" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M12.976 21.9C14.3823 21.9 15.7038 21.5372 16.852 20.9L14.7806 20.0984C13.6195 19.649 12.3325 19.649 11.1714 20.0984L9.1 20.9C10.2483 21.5372 11.5698 21.9 12.976 21.9Z", fill: fill ? themes_1.THEME.colors.basic.White100 : 'transparent', stroke: "black", strokeWidth: "1" }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 34 34" }, rest, { children: [jsx_runtime_1.jsx("circle", { cx: "17", cy: "17", r: "16", stroke: "black", strokeWidth: "1.5", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M16.9999 29C21.9799 29 26.1627 25.5873 27.3374 20.9731C27.7008 19.5458 26.4727 18.3334 24.9999 18.3334H8.99992C7.52716 18.3334 6.29905 19.5458 6.66239 20.9731C7.83709 25.5873 12.02 29 16.9999 29Z", fill: fill ? themes_1.THEME.colors.basic.White100 : 'transparent', stroke: "black", strokeWidth: "1.5" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "11.5", cy: "13", r: "1.5", fill: "black" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "22.5", cy: "13", r: "1.5", fill: "black" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M16.9679 28.8667C18.8429 28.8667 20.6049 28.3829 22.1359 27.5333L19.374 26.4645C17.8259 25.8654 16.11 25.8654 14.5619 26.4645L11.7999 27.5333C13.3309 28.3829 15.0929 28.8667 16.9679 28.8667Z", fill: fill ? themes_1.THEME.colors.basic.White100 : 'transparent', stroke: "black", strokeWidth: "1.5" }, void 0)] }), void 0));
};
var EmojiAltIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.EmojiAltIcon = EmojiAltIcon;
//# sourceMappingURL=EmojiAltIcon.js.map